import { create } from 'zustand';
import type { AccountInfo } from '@azure/msal-browser';

type AppRole = 'creator' | 'poweruser' | 'member';

interface AuthState {
  account: AccountInfo | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  role: AppRole | null;
  setAccount: (account: AccountInfo | null) => void;
  setAccessToken: (token: string | null) => void;
  setRole: (role: AppRole) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  account: null,
  accessToken: null,
  isAuthenticated: false,
  role: null,
  setAccount: (account) =>
    set({ account, isAuthenticated: !!account }),
  setAccessToken: (accessToken) =>
    set({ accessToken }),
  setRole: (role) =>
    set({ role }),
  logout: () =>
    set({ account: null, accessToken: null, isAuthenticated: false, role: null }),
}));
